import { HttpClient } from "~/services/HttpClient";
import { API_BASE_URL } from "~/config";

export class BaseService {
  baseUrl = API_BASE_URL;
  public client: HttpClient;
  constructor(baseUrl = "") {
    this.baseUrl += baseUrl;
    this.client = new HttpClient();
  }
}
